/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FunnelStageE4 interface.
 */
export function instanceOfFunnelStageE4(value) {
    if (!('activatedUsers' in value) || value['activatedUsers'] === undefined)
        return false;
    if (!('activationRate' in value) || value['activationRate'] === undefined)
        return false;
    if (!('registeredUsers' in value) || value['registeredUsers'] === undefined)
        return false;
    return true;
}
export function FunnelStageE4FromJSON(json) {
    return FunnelStageE4FromJSONTyped(json, false);
}
export function FunnelStageE4FromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'activatedUsers': json['activatedUsers'],
        'activationRate': json['activationRate'],
        'registeredUsers': json['registeredUsers'],
    };
}
export function FunnelStageE4ToJSON(json) {
    return FunnelStageE4ToJSONTyped(json, false);
}
export function FunnelStageE4ToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'activatedUsers': value['activatedUsers'],
        'activationRate': value['activationRate'],
        'registeredUsers': value['registeredUsers'],
    };
}
